jQuery(document).ready(function($){




	$('.mobile-toggle').each(function(){
		$(this).click(function(){
			$('.mobile-toggle').toggleClass('open');
			$('body').toggleClass('nav-open');
			$('.nav-col').toggleClass('open');
			$('.sub-nav-item-block').removeClass('open');
		});
	});


	$('.back-col button').each(function(){
		$(this).click(function(){
			$('.list-menu__item.has-sub').removeClass('open').attr('aria-expanded', 'false');
			$('.sub-nav-item-block').removeClass('open').find('a, button, summary, input:not([data-mobile-no-focus])').attr('tabindex', '-1');
		});
	});

	function closeNav(){
		$('.nav-item .list-menu__item.has-sub, .sub-nav-items, .sub-nav-item-block, .nav-col').removeClass('open');
		$('body, html').removeClass('nav-open');
		$('.sub-nav-item-block').find('a, button, summary, input:not([data-mobile-no-focus])').attr('tabindex', '-1');
		$('.mobile-toggle').removeClass('open');
		$('.list-menu__item.has-sub').attr('aria-expanded', 'false');

		$(window).off("scroll");
	}

	function scrollCheck(){
		$(window).on("scroll",function(){
			closeNav();
		})
	}

	$('.nav-item .list-menu__item.has-sub').on('click',function(e) {
		var trigger = $(this).attr('id');
		var width = window.innerWidth;


		if (width >= 992) {
			e.preventDefault();
			var dropdownArea  = $('.sub-nav-items');
			var containerHeight = $('#sub-' + trigger).outerHeight() + 8;


			if($(this).hasClass('open')){
				closeNav();
			}else{
				dropdownArea.css('height',containerHeight);
				$('.nav-item .list-menu__item.has-sub').removeClass('open').attr('aria-expanded', 'false');
				$('.sub-nav-item-block').removeClass('open');
				$(this).addClass('open').attr('aria-expanded', 'true');
				$(dropdownArea).addClass('open');
				$('body, html').addClass('nav-open');
				$('.nav-col, #sub-' + trigger).toggleClass('open');
				$('.sub-nav-item-block.open').find('a, button, summary, input:not([data-mobile-no-focus])').removeAttr('tabindex');

				scrollCheck();
			}
		}else{
			$('#sub-' + trigger).addClass('open').find('a, button, summary, input:not([data-mobile-no-focus])').removeAttr('tabindex');
		}
	});



	$('body').on('click keydown keyup', function(event) {
		var width = window.innerWidth;

		if (width >= 992) {
			if (event.type == 'keyup') {
				if ($(event.target).closest('.list-menu__item').length == 0 && $(event.target).closest('.sub-nav-items').length == 0 ) {
					if($('.sub-nav-items').hasClass('open')){
						closeNav();
					}
				}
				return;
			}

			if (event.type == 'keydown') {
				if (event.which == 27) {

					if($('.sub-nav-items').hasClass('open')){
						closeNav();
					}
				}

				return;
			}

			if ($(event.target).closest('.list-menu__item').length == 0 && $(event.target).closest('.sub-nav-items').length == 0 ) {
				closeNav();
			}
		}

	});

	$(window).on('resize', function () {
		closeNav();
	});




	// Slick Sliders
	$('.slick-slider').each(function () {
		var id = $(this).attr('id');

			if (id == ('hero-slider')) {
	            $(this).slick({
	                accessibility: true,
	                autoplay: true,
					autoplaySpeed: 5000,
	                arrows: true,
					prevArrow: $('#' + id + '-arrow-prev'),
					nextArrow: $('#' + id + '-arrow-next'),
	                dots: true,
	                adaptiveHeight:true,
	                appendDots:"#line-dots",
	                cssEase: 'ease-out',
	                slidesToShow: 1,
	                infinite: true,
	                slidesToScroll: 1,
	                speed: 300,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								arrows:false
							}
						}
					]
	            });

	            $('.home-slide').addClass('loaded');
				$('.home-slider .paused').removeClass('paused');

			}else if (id == ('main-gallery')){
				$(this).slick({
					accessibility: true,
					autoplay: false,
					arrows: false,
					dots: false,
					adaptiveHeight:false,
					asNavFor: '#control-gallery',
					cssEase: 'ease-out',
					slidesToShow: 1,
					infinite: true,
					slidesToScroll: 1,
					speed: 300
				});

				$('.main-img-slide').addClass('loaded');
			}else if (id == ('control-gallery')){
				$(this).slick({
					accessibility: true,
					autoplay: false,
					arrows: false,
					dots: false,
					adaptiveHeight:false,
					asNavFor: '#main-gallery',
					cssEase: 'ease-out',
					slidesToShow: 5,
					infinite: true,
					slidesToScroll: 1,
					speed: 300
				});

				$('.control-img-slide').addClass('loaded');
			}
		});


	//price ranges
	(function () {
		let USDollar = new Intl.NumberFormat('en-US', {
		    style: 'currency',
		    currency: 'USD',
		});

		$('.prod-details .price[data-variants], .grid-item .price[data-variants]').each(function () {
			let variants     = $(this).data('variants'),
				msrps,
				sales,
				minPrice,
				maxPrice,
				saleMinPrice,
				saleMaxPrice,
				rangeDiffers;

			if (typeof variants.map !== 'function') {
				return;
			}

			msrps        = variants.map(function (variant) { if (variant.compare_at_price !== null) { return variant.compare_at_price; } else { return variant.price; }});
			sales        = variants.map(function (variant) { return variant.price; });
			minPrice     = Math.min(...msrps);
			maxPrice     = Math.max(...msrps);
			saleMinPrice = Math.min(...sales);
			saleMaxPrice = Math.max(...sales);
			rangeDiffers = false;

			if (saleMinPrice !== minPrice || saleMaxPrice !== maxPrice) {
				rangeDiffers = true;
			}

			minPrice     = USDollar.format(minPrice / 100);
			maxPrice     = USDollar.format(maxPrice / 100);
			saleMinPrice = USDollar.format(saleMinPrice / 100);
			saleMaxPrice = USDollar.format(saleMaxPrice / 100);

			if (rangeDiffers) {
				$(this).html('<p class="sm dark-gray price">' + saleMinPrice + ' - ' + saleMaxPrice + '<s class="sm gray original-price">' + minPrice + ' - ' + maxPrice + '</s></p>');
			}
		});
	}());

	//product variation selection
	(function () {
		let USDollar = new Intl.NumberFormat('en-US', {
		    style: 'currency',
		    currency: 'USD',
		});

		$('.shopify-product-form').each(function () {
			var form                 = $(this),
				imgDisplay           = $('.main-img'),
				skuDisplay           = $('[data-js="sku"]'),
				partNumDisplay       = $('[data-js="part-number"]'),
				packageQtyDisplay    = $('[data-js="package-quantity"]'),
				descriptionDisplay   = $('[data-js="product-description"]'),
				currentPriceDisplay  = form.find('[data-js="current-price"]'),
				originalPriceDisplay = form.find('[data-js="original-price"]'),
				variants             = $('[data-js="variants"]').text(),
				variantMetadata      = $('[data-js="variant-metadata"]').text(),
				variantInput         = form.find('input[name="id"]'),
				productImages        = $('[data-js="product-images"]').text(),
				cartNotification     = new CartNotification();

			try {
				if (variants) {
					variants = JSON.parse(variants);
				} else {
					variants = false;
				}
			} catch (error) {
				variants = false;
			}

			try {
				if (variantMetadata) {
					variantMetadata = JSON.parse(variantMetadata);
				} else {
					variantMetadata = false;
				}
			} catch (error) {
				variantMetadata = false;
			}

			try {
				if (productImages) {
					productImages = JSON.parse(productImages);
				} else {
					productImages = false;
				}
			} catch (error) {
				productImages = false;
			}

			function getSelectedOptions() {
				return form.find('.option-select.selected').map(function () { var option = $(this); return option.data('value'); }).get();
			}

			function getAvailableVariants(option, value) {
				return variants.filter(function (variant) { return variant['option' + option] == value && variant.available; });
			}

			function getCompatibleOptions(option, value) {
				var availableVariants = getAvailableVariants(option, value),
					compatibleOptions = {};

				for (let i = 0; i < availableVariants.length; i++) {
					for (let optionNum = 2; optionNum < 4; optionNum++) { //don't update option 1, we don't want to get locked into a selection

						if (optionNum == option) {
							continue;
						}

						if (availableVariants[i]['option' + optionNum] == null) {
							continue;
						}

						if (!Array.isArray(compatibleOptions[optionNum])) {
							compatibleOptions[optionNum] = [];
						}

						compatibleOptions[optionNum].push(availableVariants[i]['option' + optionNum]);
					}
				}

				return compatibleOptions;
			}

			function updateOtherOptions(option, value) {
				var compatibleOptions = getCompatibleOptions(option, value);

				for (key in compatibleOptions) {
					form.find('.option-select[data-option="' + key + '"]').each(function () {
						var button = $(this);

						if (compatibleOptions[key].includes("" + button.data('value'))) {
							button.prop('disabled', false).removeClass('disabled');
						} else {
							button.prop('disabled', true).addClass('disabled');
						}
					});
				}
			}

			function getSelectedVariant() {
				let matchingVariant = variants.filter(function (variant) {
					var matches         = true,
						selectedOptions = getSelectedOptions();

					for (let i = 0; i < selectedOptions.length; i++) {
						if (variant['option' + (i + 1)] != selectedOptions[i]) {
							matches = false;
							break;
						}
					}

					return matches;
				})[0];

				if (matchingVariant && matchingVariant.available) {
					return matchingVariant;
				} else {
					return undefined;
				}
			}

			function handleErrorMessage(errorMessage = false) {
				var errMsgWrapperElem = document.querySelector('.product-form__error-message-wrapper');

				if (!errMsgWrapperElem) return;

				var errMsgElem = errMsgWrapperElem.querySelector('.product-form__error-message');

				errMsgWrapperElem.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					errMsgElem.textContent = errorMessage;
				}
			}

			form.on('click', '.option-select', function () {
				var button            = $(this),
					option            = button.data('option'),
					value             = button.data('value'),
					selectionDisplay  = button.closest('.options').find('[data-js="option' + option + '-selected"]'),
					selectedVariant,
					addToCartBtn      = $('button.add-btn');

				if (button.is('.selected')) {
					button.removeClass('selected');
				} else {
					button.closest('.options-row').find('button').removeClass('selected');
					button.addClass('selected');
				}

				selectionDisplay.text(value);

				selectedVariant = getSelectedVariant();

				if (selectedVariant) {

					variantInput.val(selectedVariant.id);

					(function () {
						//swap the product image
						let variant_image = selectedVariant.featured_image;
						let product_image = imgDisplay.data('default');

						//ensure images are URL strings
						if (typeof variant_image == 'object' && variant_image !== null && variant_image.hasOwnProperty('src')) {
							variant_image = variant_image.src;
						}
						if (typeof product == 'object' && product_image !== null && product_image.hasOwnProperty('src')) {
							product_image = product_image.src;
						}

						if (variant_image) {
							imgDisplay.css('background-image', 'url(' + variant_image + ')');
						} else {
							imgDisplay.css('background-image', 'url(' + product_image + ')');
						}
					}());

					// skuDisplay.text("SKU#: " + selectedVariant.sku);

					// if (variantMetadata[selectedVariant.id].part_number && variantMetadata[selectedVariant.id].part_number !== selectedVariant.sku) {
					// 	partNumDisplay.show().text("Part#: " + variantMetadata[selectedVariant.id].part_number);
					// } else if (!variantMetadata[selectedVariant.id].part_number && partNumDisplay.data('default') && partNumDisplay.data('default') !== selectedVariant.sku) {
					// 	partNumDisplay.show().text("Part#: " + partNumDisplay.data('default'));
					// } else {
					// 	partNumDisplay.hide();
					// }

					skuDisplay.text("").hide();

					if (variantMetadata[selectedVariant.id].part_number) {
						partNumDisplay.css('visibility', 'visible').text("Part#: " + variantMetadata[selectedVariant.id].part_number);
					} else if (partNumDisplay.data('default')) {
						partNumDisplay.css('visibility', 'visible').text("Part#: " + partNumDisplay.data('default'));
					} else {
						partNumDisplay.css('visibility', 'hidden');
					}

					if (variantMetadata[selectedVariant.id].package_quantity) {
						packageQtyDisplay.css('visibility', 'visible').text("Package Quantity: " + variantMetadata[selectedVariant.id].package_quantity);
					} else if (packageQtyDisplay.data('default')) {
						packageQtyDisplay.css('visibility', 'visible').text("Package Quantity: " + packageQtyDisplay.data('default'));
					} else {
						packageQtyDisplay.css('visibility', 'hidden');
					}

					if (variantMetadata[selectedVariant.id].description) {
						descriptionDisplay.css('visibility', 'visible').text(variantMetadata[selectedVariant.id].description);
					} else if (descriptionDisplay.data('default')) {
						descriptionDisplay.css('visibility', 'visible').text(descriptionDisplay.data('default'));
					} else {
						descriptionDisplay.css('visibility', 'hidden');
					}

					currentPriceDisplay.css('visibility', 'visible').text(USDollar.format(selectedVariant.price / 100));

					if (selectedVariant.compare_at_price) {
						originalPriceDisplay.css('visibility', 'visible').text(USDollar.format(selectedVariant.compare_at_price / 100));
					} else {
						originalPriceDisplay.css('visibility', 'hidden').text('');
					}

					addToCartBtn.removeClass('out-of-stock').prop('disabled', false).text('Add to Cart');

					//update the specs table
					$('.specs-pane:not(.default)').show();
					$('.specs-pane.default').hide();
					$.ajax({
						url: window.location.pathname + `?variant=${selectedVariant.id}`,
						success: function (pageContent) {
							var htmlDoc  = $((new DOMParser()).parseFromString(pageContent, "text/html")),
								newSpecs = htmlDoc.find('.specs-pane:not(.default)');

							//don't update the specs table unless the requested specs still match the currently selected variant
							if (selectedVariant == getSelectedVariant()) {
								$('.specs-pane:not(.default)').replaceWith(newSpecs);
							}
						}
					});

					window.history.replaceState({}, '', window.location.pathname + `?variant=${selectedVariant.id}`);

				} else {
					variantInput.val('');

					skuDisplay.hide();
					
					if (partNumDisplay.data('default')) {
						partNumDisplay.css('visibility', 'visible').text("Part#: " + partNumDisplay.data('default'));
					} else {
						partNumDisplay.css('visibility', 'hidden');
					}

					if (packageQtyDisplay.data('default')) {
						packageQtyDisplay.css('visibility', 'visible').text("Package Quantity: " + packageQtyDisplay.data('default'));
					} else {
						packageQtyDisplay.css('visibility', 'hidden');
					}

					currentPriceDisplay.css('visibility', 'hidden');
					originalPriceDisplay.css('visibility', 'hidden');

					addToCartBtn.addClass('out-of-stock').prop('disabled', true).text('Out of Stock');

					//display default specs table
					$('.specs-pane:not(.default)').hide();
					$('.specs-pane.default').show();

					window.history.replaceState({}, '', window.location.pathname);
				}

				updateOtherOptions(option, value);
			});

			form.on('submit', function(event) {
				event.preventDefault(); // prevent default form submission

				form.find('input[name="sections"]').val(cartNotification.getSectionsToRender().map((section) => section.id));
				
				$.ajax({
					type: 'POST',
					url: '/cart/add.js',
					data: form.serialize(),
					dataType: 'json',
					success: function(cart_item) {

						$.ajax({
							type: 'GET',
							url: '/cart.js',
							dataType: 'json',
							success: function (cart) {

								var countMarkup = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' item' + (cart.item_count != 1 ? 's' : '') + '</span>'

								$('.cart-link').each(function () {
									var cartIcon    = $(this),
										cartCount   = cartIcon.find('.cart-count-bubble');

									if (cartCount.length == 0) {
										cartIcon.append('<div class="cart-count-bubble">' + countMarkup + '</div>');
									} else {
										cartCount.html(countMarkup);
									}
								});

								handleErrorMessage(cart_item.description);

								cartNotification.renderContents(cart_item);
								cartNotification.open();
							}
						});
					},
					error: function(jqXHR) {
						handleErrorMessage(jqXHR.responseJSON.description);
					}
				});
			});
		});

		// console.log('subscribe', subscribe);
		subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
			$.ajax({
				type: 'GET',
				url: '/cart.js',
				dataType: 'json',
				success: function (cart) {

					var countMarkup = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' item' + (cart.item_count != 1 ? 's' : '') + '</span>'

					$('#mobile-cart-icon-bubble').each(function () {
						var cartIcon    = $(this),
							cartCount   = cartIcon.find('.cart-count-bubble');

						if (cartCount.length == 0) {
							cartIcon.append('<div class="cart-count-bubble">' + countMarkup + '</div>');
						} else {
							cartCount.html(countMarkup);
						}
					});
				}
			});
		});
	}());

	//list all collections
	(function () {

		const CATEGORY_TYPE = 0,
			  HEADLINE      = 1,
			  REVERSED_LOGO = 2;

		function getQuery(cursor = false) {
			if (cursor) {

				return `{
							collections (sortKey: TITLE, first: 250, after: "${cursor}") {
								edges {
									node {
										handle,
										title,
										description,
										image {
											url
										},
										metafields (identifiers: [{namespace: "custom_fields", key: "category_type"}, {namespace: "custom_fields", key: "headline"}, {namespace: "custom_fields", key: "reversed_logo_image"}]) {
											value
										}
									}
								}
								pageInfo {
									hasPreviousPage
									hasNextPage
									startCursor
									endCursor
								}
							}
						}`;

			} else {
				return `{
							collections (sortKey: TITLE, first: 250) {
								edges {
									node {
										handle,
										title,
										description,
										image {
											url
										},
										metafields (identifiers: [{namespace: "custom_fields", key: "category_type"}, {namespace: "custom_fields", key: "headline"}, {namespace: "custom_fields", key: "reversed_logo_image"}]) {
											value
										}
									}
								}
								pageInfo {
									hasPreviousPage
									hasNextPage
									startCursor
									endCursor
								}
							}
						}`;
			}
		}

		function getBlockMarkup(collection) {
			if (collection.metafields[CATEGORY_TYPE]) {
				if (collection.metafields[CATEGORY_TYPE].value == 'Collection') {
					return `<div class="collection col-12 col-lg-6">
								<a href="/collections/${collection.handle}" class="collection-inner row g-0 align-items-end">
									<div class="collection-bg" style="background-image:url(${collection.image.url})">
									</div>
									<div class="overlay">
									</div>
									<div class="copy col-12">
										<p class="white sm">
											${collection.metafields[CATEGORY_TYPE].value}
										</p>
										<h1 class="xs white bold">
											${collection.title}
										</h1>
									</div>
								</a>
							</div>`;
				} else if (collection.metafields[CATEGORY_TYPE].value == 'Brand') {
					return `<div class="collection col-12 col-lg-6">
								<a href="/collections/${collection.handle}" class="collection-inner row g-0 align-items-end">
									<div class="collection-bg" style="background-image:url(${collection.image.url})">
									</div>
									<div class="overlay tall">
									</div>
									<div class="logo">
										<img src="${collection.metafields[REVERSED_LOGO].value}" />
									</div>
									<div class="copy col-12">
										<p class="align-center white sm">
											${collection.description}
										</p>
									</div>
								</a>
							</div>`;
				}
			}
		}


		$('.collections-listing-page').each(function () {

			var list        = $('.collections-list'),
				collections = [],
				type        = $(this).data('type'),
				done        = $.Deferred();

			function fetchResults(cursor = false) {
				$.ajax({
					method: 'POST',
					url: '/api/2024-01/graphql.json',
					contentType: 'application/json',
					headers: {
						'X-Shopify-Storefront-Access-Token': 'f180358850ff5448941f2b55000642dc'
					},
					data: JSON.stringify({
						query: getQuery(cursor)
					}),
					success: function (response) {
						for (let i = 0; i < response.data.collections.edges.length; i++) {
							collections.push(response.data.collections.edges[i].node);
						}

						if (response.data.collections.pageInfo.hasNextPage) {

							fetchResults(response.data.collections.pageInfo.endCursor)
						} else {
							done.resolve();
						}
					}
				});
			}

			done.then(function () {
				list.html('');

				for (let i = 0; i < collections.length; i++) {
					let collection = collections[i];

					if (collection.metafields[CATEGORY_TYPE] && collection.metafields[CATEGORY_TYPE].value == type) {

						list.append(getBlockMarkup(collection));
					}
				}
			});

			fetchResults();
		});
	}());

	$('.parallax-window').each(function(index) {
		var triggerWindow = '#window-' + index,
			standardTween,
			image = triggerWindow + ' .parallax-image',
			scene;
			var width = window.innerWidth

		if(width >= 992) {
			// init controller
			var controller = new ScrollMagic.Controller();

			// standard y parallax images

			$(this).attr('id', triggerWindow.slice(1));


			// build tween
			standardTween = TweenMax.to(triggerWindow + ' .parallax-image', 1, {y: '-35%', ease: Linear.easeNone});

			// build scene
			scene = new ScrollMagic.Scene({
				triggerElement: triggerWindow,
				triggerHook: 'onEnter',
				duration: '200%'
			})
			.setTween(standardTween)
			.addTo(controller);

			// tell image that parallax function ran
			$(image).addClass('parallax-js-loaded');

		} else {
			$(image).css('transform','none');
		}
	});



		function filterHeights() {
			setTimeout(
			  function()
			  {
					if($('.boost-pfs-filter-option-content').length > 0){
						$('.boost-pfs-filter-option-content').each(function(){
							var width = window.innerWidth
							var filterHeight = $(this).outerHeight();


							if(width >= 992) {
								$(this).css('max-height',filterHeight);
							} else {
								$(this).css('max-height','none');
							}

						});
					}
				}, 5000);
		}

		filterHeights();

		$(window).on('resize', function () {
			filterHeights();
		});

});
